import { useContext } from "react";
import context, { IOrganisationProviderContext } from "../state/context";

export default (): IOrganisationProviderContext => useContext(context);
